<template>
  <modal
    class="edit-list-modal"
    name="EditListModal"
    :maxWidth="550"
    :adaptive="true"
    draggable=".edit-modal-window-title"
    height="auto"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    @opened="opened"
  >
    <div class="modal-edit-list-container">
      <div v-if="!listLoaded" class="list-loaded-spinner-wrapper">
        <Spinner size="64" />
      </div>
      <EditList v-show="listLoaded" :list="list" @cancel="cancel()" />
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";

import EditList from "@/components/edit/list/EditList";

import cache from "../store/cache";
import urlManager from "../common/urls";
export default {
  name: "EditListModal",
  components: { EditList },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    listLoaded() {
      return !!this.list;
    }
  },
  methods: {
    cancel() {
      this.$modal.hide("EditListModal");
    },
    beforeClose(event) {
      if (this.$store.state.dialogs.confirmation) {
        event.stop();
        return;
      }

      this.list = null;
      this.listId = null;

      urlManager.toCurrentBoard();
    },
    beforeOpen(event) {
      this.list = event.params.list;
      this.listId = parseInt(event.params.listId);
    },
    async opened() {
      if (this.list) {
        return;
      }
      const id = this.listId;

      this.list = await cache.tryGet(() => cache.lists.byId(id), 10000);
      if (!this.list) {
        this.cancel();

        this.$snotify.error("Не удалось загрузить список", {
          timeout: 1000,
          showProgressBar: false
        });
      }
    }
  },
  data() {
    return {
      list: null,
      listId: null
    };
  }
};
</script>

<style lang="postcss">
.edit-list-modal {
  .modal-edit-list-container {
    .list-loaded-spinner-wrapper {
      min-height: 200px;
      padding-top: calc(100px - 32px);
    }
  }
}
</style>


